import { render, staticRenderFns } from "./summaryindex.vue?vue&type=template&id=6f4abf38&"
import script from "./summaryindex.vue?vue&type=script&lang=js&"
export * from "./summaryindex.vue?vue&type=script&lang=js&"
import style0 from "./summaryindex.vue?vue&type=style&index=0&id=6f4abf38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports